import { Pipe, PipeTransform } from '@angular/core';
import {
  dobDisplayFormatUsesPadding,
  formatDobMdY,
} from '../utils/dob-display.util';

@Pipe({
  name: 'dateWithoutTimezone'
})
export class DateWithoutTimezonePipe implements PipeTransform {
  /**
   * Format DOB / date-only values without UTC “off by one day” issues.
   * Strips `T00:00:00.000Z` (and similar) before formatting as `M/d/yyyy` or `MM/dd/yyyy`.
   */
  transform(date: string | null | undefined, format?: string): string {
    if (date == null || date === "") {
      return "";
    }
    const padded = dobDisplayFormatUsesPadding(format);
    return formatDobMdY(date, padded);
  }

}
